import { initialBannerPublishEvent } from 'shared/util/podletMessageBusEvents';
import { ObjectLocation } from '@/interfaces';

export const publishBannerEvent = (location?: Partial<ObjectLocation>) => {
    let city = '';
    let country = '';

    if (location) {
        city = location?.locality || location?.address?.split(',')?.slice(-2)[0].trim() || null;
        country = location?.country || location?.address?.split(',')?.slice(-1)[0].trim() || null;
    }

    // @ts-ignore convert this function to ts
    initialBannerPublishEvent({
        pageType: 'object',
        country,
        city,
    });
};
